// v3.3 (F3): tiny platform helper. Every native-vs-web branch (camera, push, voice) keys off
// this, so the same source runs as the web app / installable PWA and, later, inside a
// Capacitor native shell without code changes.
export const isNative = () => {
  try {
    const cap = typeof window !== 'undefined' ? window.Capacitor : null
    if (!cap) return false
    return typeof cap.isNativePlatform === 'function' ? cap.isNativePlatform() : !!cap.isNative
  } catch {
    return false
  }
}

// A stable id for idempotency keys (agent money actions) — prefers crypto.randomUUID.
export const newIdemKey = () => {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  } catch { /* ignore */ }
  return `k-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export default { isNative, newIdemKey }
